export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7775.dda4a3de.jpg";